import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type {
	BuilderContextProvidersPageConfig,
	BuilderContextProvidersSiteConfig,
	ContextProviderLoader,
} from './types'
import { name, ContextProviderLoaderSymbol } from './symbols'
import { filterContextProvidersForImportMap } from './importMapReducer'
import { ImportMapSymbol } from 'feature-builder-module-loader'
import type { ImportMap } from 'feature-builder-module-loader'

export const BuilderContextProvidersPageWillMountHandler = withDependencies(
	[
		named(SiteFeatureConfigSymbol, name),
		named(PageFeatureConfigSymbol, name),
		ImportMapSymbol,
		ContextProviderLoaderSymbol,
	],
	(
		siteFeatureConfig: BuilderContextProvidersSiteConfig,
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		importMap: ImportMap,
		contextProviderLoader: ContextProviderLoader
	): IPageWillMountHandler => {
		return {
			name: 'builderContextProvidersLoader',
			pageWillMount: async () => {
				importMap.updateImportMap(filterContextProvidersForImportMap(siteFeatureConfig.contextProviders))
				await Promise.all(
					Object.keys(pageFeatureConfig.compIdToContextsMap).map((compId) =>
						contextProviderLoader.retrieveContextProviders(compId)
					)
				)
			},
		}
	}
)
